import React from 'react';

const NavItem = ({title, onClick, active, ...props}) => {
    return <a href="javascript:void()" className={'nav-item' + (active ? ' active' : '')} onClick={() => onClick()} {...props}>{title}</a>
}

export default NavItem;